module.exports = __webpack_public_path__ + "static/media/vf_mshirts_core.970d8b0c.svg";